export const postableTypes = {
  POST: "post",
  COMMENT: "comment"
}
